export default __webpack_public_path__ + "4181f2a4c6bd0136fd3a35eb3ccd0442.png";